const $755957079a54393b$export$de7ead42144ee87f = document.querySelector(":root");
function $755957079a54393b$export$71511d61b312f219(id) {
    return document.getElementById(id);
}
function $755957079a54393b$export$3d8c2f653ac9d0b9(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}




function $e3e66118ecb9a43a$export$2e2bcd8739ae039({ header: header, logo: logo }) {
    const COLLAPSED_HEADER_HEIGHT = 50;
    const EXPANDED_HEADER_HEIGHT = 90;
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        initialized = true;
        _addScrollListener();
    }
    function _addScrollListener() {
        window.addEventListener("scroll", (e)=>{
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
            _handleHeaderOnScroll(scrollTop);
        });
    }
    function _handleHeaderOnScroll(scrollTop) {
        if (scrollTop > 0) _collapseHeader();
        else _expandHeader();
    }
    function _collapseHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", COLLAPSED_HEADER_HEIGHT + "px");
        header.classList.add("header-collapsed");
        logo.classList.add("logo-collapsed");
    }
    function _expandHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", EXPANDED_HEADER_HEIGHT + "px");
        header.classList.remove("header-collapsed");
        logo.classList.remove("logo-collapsed");
    }
}



class $f6e6a130867ac54c$export$2e2bcd8739ae039 {
    _overlay;
    _redirectUrl;
    _overlayBox;
    constructor(overlay, redirectUrl){
        this._overlay = overlay;
        this._redirectUrl = redirectUrl;
        this._addOnCloseListener();
        this._overlayBox = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-box")[0];
    }
    set(redirectUrl) {
        this._redirectUrl = redirectUrl;
    }
    render(content) {
        const wrapper = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-content")[0];
        wrapper.replaceChildren();
        wrapper.append(content);
        this.show();
    }
    show() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-scroll");
        this._overlay.classList.add("overlay-change");
        this._overlayBox.classList.add("overlay-box-change");
    }
    _addOnCloseListener() {
        this._overlay.addEventListener("click", (e)=>{
            this._onClose(e);
        });
    }
    _onClose(e) {
        const target = e.target;
        if (target === this._overlay) this.hide();
    }
    hide() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-scroll");
        this._overlayBox.classList.remove("overlay-box-change");
        setTimeout(()=>{
            this._overlay.classList.remove("overlay-change");
            if (this._redirectUrl) window.location.href = this._redirectUrl;
        }, 300);
    }
}


function $0916120d17a98724$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (!settingsBtn || !settingsOverlay) return;
        if (initialized) return;
        const SettingsOverlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(settingsOverlay);
        settingsBtn.addEventListener("click", ()=>{
            SettingsOverlay.show();
        });
        initialized = true;
    }
}


function $5521a363e3fdef1c$var$makeEventRouter() {
    const router = {
        "": {
            execute: async ()=>{}
        }
    };
    const routerWithData = {};
    return Object.freeze({
        get: get,
        getWithData: getWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
}
const $5521a363e3fdef1c$var$APP_VIEWS = $5521a363e3fdef1c$var$makeEventRouter();
var $5521a363e3fdef1c$export$2e2bcd8739ae039 = $5521a363e3fdef1c$var$APP_VIEWS;


function $e140cc3a0fd3203c$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay, header: header, logo: logo }) {
    _initAppShell();
    return Object.freeze({
        resize: resize,
        executeEvent: executeEvent,
        executeEventWithData: executeEventWithData
    });
    function _initAppShell() {
        (0, $0916120d17a98724$export$2e2bcd8739ae039)({
            settingsBtn: settingsBtn,
            settingsOverlay: settingsOverlay
        }).init();
        (0, $e3e66118ecb9a43a$export$2e2bcd8739ae039)({
            header: header,
            logo: logo
        }).init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = (0, $5521a363e3fdef1c$export$2e2bcd8739ae039).get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = (0, $5521a363e3fdef1c$export$2e2bcd8739ae039).getWithData(detail.action);
        await view.execute(detail.data);
    }
}


(async function() {
    const overlays = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".overlay");
    overlays.forEach((overlay)=>overlay.classList.remove("no-display"));
    const app = (0, $e140cc3a0fd3203c$export$2e2bcd8739ae039)({
        settingsBtn: (0, $755957079a54393b$export$71511d61b312f219)("settingsBtn"),
        settingsOverlay: (0, $755957079a54393b$export$71511d61b312f219)("settingsOverlay"),
        header: (0, $755957079a54393b$export$71511d61b312f219)("header"),
        logo: (0, $755957079a54393b$export$71511d61b312f219)("logo")
    });
    app.resize();
    window.addEventListener("app-event", (e)=>{
        app.executeEvent(e.detail.action);
    });
    window.addEventListener("app-event-with-data", (e)=>{
        app.executeEventWithData(e.detail);
    });
    window.addEventListener("resize", app.resize);
    document.documentElement.addEventListener("touchstart", function(e) {}); //hover behaviour on touch devices
})();


//# sourceMappingURL=index.26e5112d.js.map
